import { FiUpload } from "react-icons/fi";
function ImageDropZone({ onClick }) {
    const styles = {
        wrapper: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            border: "2px dashed #d1d5db",
            borderRadius: "6px",
            backgroundColor: "#f3f4f6",
            cursor: "pointer",
        },
        contentContainer: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "24px",
            minHeight: "220px",
            icon: {
                width: "40px",
                height: "40px",
                color: "#3b82f6",
                marginBottom: "8px",
            },
            text: {
                fontSize: "16px",
                color: "#71717a",
                margin: "0",
                textAlign: "center"
            },
            remaining: {
                fontSize: "12px",
                color: "#71717a",
                margin: "0",
            },
        },
    };
    return (
        <div onClick={onClick} style={styles.wrapper}>
            <div style={styles.contentContainer}>
                <FiUpload style={styles.contentContainer.icon} />
                <p style={styles.contentContainer.text}>Drag and drop or click to add more images</p>
                <p style={styles.contentContainer.remaining}>4 slots remaining</p>
            </div>
        </div>
    )
}

export default ImageDropZone;